export default __webpack_public_path__ + "static/media/download.a2f55c2c.svg";